import { Link } from 'react-router-dom'
import { SOCIAL_LINKS } from '@/constants/products'
import logo from '@/assets/images/logo/Logo-100p.png'
import { FaFacebookF, FaInstagram } from 'react-icons/fa6'
import { useI18n } from '@/hooks'

const Footer = () => {
  const { t } = useI18n()

  return (
    <footer className="bg-gray-50 py-12 px-4">
      <div className="max-w-6xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* About us */}
          <div>
            <h4 className="font-semibold text-gray-800 mb-4">
              {t.aboutUs}
            </h4>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/about"
                  className="text-gray-600 hover:text-gray-800 transition-colors"
                >
                  {t.ourStory}
                </Link>
              </li>
              <li>
                <Link
                  to="/shop"
                  className="text-gray-600 hover:text-gray-800 transition-colors"
                >
                  {t.ourProducts}
                </Link>
              </li>
              <li>
                <a 
                  href="/privacy-policy" 
                  className="text-gray-600 hover:text-gray-800 transition-colors"
                >
                  {t.privacyPolicy}
                </a>
              </li>
              <li>
                <a 
                  href="/refund-returns" 
                  className="text-gray-600 hover:text-gray-800 transition-colors"
                >
                  {t.refundReturns}
                </a>
              </li>
            </ul>
          </div>

          {/* Contact us */}
          <div>
            <h4 className="font-semibold text-gray-800 mb-4">
              {t.contactUs}
            </h4>
            <ul className="space-y-2">
              <li>
                <a 
                  href="mailto:service@cloutyspace.com"
                  className="text-gray-600 hover:text-gray-800 transition-colors"
                >
                  service@cloutyspace.com
                </a>
              </li>
            </ul>
          </div>

          {/* Profile */}
          <div>
            <h4 className="font-semibold text-gray-800 mb-4">
              {t.profile}
            </h4>
            <ul className="space-y-2">
              <li>
                <span className="text-gray-600">
                  {t.myAccount}
                </span>
              </li>
              <li>
                <span className="text-gray-600">
                  {t.checkout}
                </span>
              </li>
            </ul>
          </div>

          {/* Follow us */}
          <div>
            <h4 className="font-semibold text-gray-800 mb-4">
              {t.followUs}
            </h4>
            <div className="flex space-x-4">
              <a 
                href={SOCIAL_LINKS.facebook}
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-600 hover:text-blue-500 transition-colors"
              >
                <div className="w-8 h-8 bg-gray-200 rounded-full flex items-center justify-center hover:bg-blue-500 hover:text-white transition-all duration-300">
                  <FaFacebookF size={16} />
                </div>
              </a>
              <a 
                href={SOCIAL_LINKS.instagram}
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-600 hover:text-pink-500 transition-colors"
              >
                <div className="w-8 h-8 bg-gray-200 rounded-full flex items-center justify-center hover:bg-pink-500 hover:text-white transition-all duration-300">
                  <FaInstagram size={16} />
                </div>
              </a>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="border-t border-gray-200 mt-8 pt-8 text-center">
          <p className="text-gray-600 text-sm">
            Copyright © 2022 Clouty Space, All Rights Reserved
          </p>
          <div className="mt-4">
            <img 
              src={logo}
              alt="Clouty Space Logo" 
              className="h-8 mx-auto opacity-70"
            />
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer
